var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5L8.46967 11.0303L9 11.5607L9.53033 11.0303L9 10.5ZM9.75 3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75L9.75 3.75ZM4.71967 7.28033L8.46967 11.0303L9.53033 9.96967L5.78033 6.21967L4.71967 7.28033ZM9.53033 11.0303L13.2803 7.28033L12.2197 6.21967L8.46967 9.96967L9.53033 11.0303ZM9.75 10.5L9.75 3.75L8.25 3.75L8.25 10.5L9.75 10.5Z",
    fill: "#2B3990"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12L3.75 12.75C3.75 13.5784 4.42157 14.25 5.25 14.25L12.75 14.25C13.5784 14.25 14.25 13.5784 14.25 12.75V12",
    stroke: "#2B3990",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.078ce5b2c24ac14a59112b4f6be22c4d.svg";
export { ForwardRef as ReactComponent };